import getStyles from "./styles";
import { Box, Container, Typography } from "@mui/material";
import { useAppSelector } from "../../redux";
import { selectReleaseDate, selectVersion } from "../../AppSlice";
import theme from "../../theme";

export default function _Footer() {
  const styles = getStyles();

  const releaseDate = useAppSelector(selectReleaseDate);
  const version = useAppSelector(selectVersion);

  return (
    <Box sx={styles.root}>
      <Box component="footer" sx={styles.footer}>
        <Container maxWidth="sm">
          <Typography
            variant="body1"
            sx={{
              [theme.breakpoints.down("sm")]: {
                fontSize: 12,
              },
              [theme.breakpoints.down("xs")]: {
                fontSize: 12,
              },
            }}
          >
            PANEEM version {version} - {releaseDate}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              [theme.breakpoints.down("sm")]: {
                fontSize: 10,
              },
              [theme.breakpoints.down("xs")]: {
                fontSize: 10,
              },
            }}
          >
            Copyright © Claims Conference {new Date().getFullYear()}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
